import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import GlobalStyle from './style/global';
import styled from 'styled-components';
import App from './pages/App';
import ErrorBoundary from './components/ErrorBoundary';
import { initLogging } from './utils/logger';
import { initLogRocket } from './utils/logrocket';
import { hasAcceptedCookies } from './components/CookieConsent';
import './index.css';
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

// Session recording is optional tracking: only with accepted cookie consent.
// Otherwise it starts when the visitor taps Accept on the cookie banner.
if (hasAcceptedCookies()) initLogRocket();
initLogging();

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

ReactDOM.render(
  <Wrapper>
    <GlobalStyle />
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </Wrapper>,
  document.getElementById('root'),
);
